import { fetchGet } from 'helpers/utils'
import { getParam } from '../../helpers/parameters'

export const apiFetchDevices = async () => {
  const contentApiUrl = await getParam('contentApiUrl')
  return fetchGet(`${contentApiUrl}/phones`)
}
